



























export default {
  name: "RoundLoading",
  props: {
    percentage: {
      type: Number,
      default: 0
    },
    borderColor: {
      type: String,
      default: "#2d4040"
    },
    borderBackground: {
      type: String,
      default: "#dcdcdc"
    },
    endless: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getPercentage(): number {
      return 1000 - 2.51 * (this.endless ? 25 : this.percentage);
    },

    hasRotation(): string {
      return this.endless ? "rotating" : "";
    }
  }
};
